export const reduceDeleteError = (state, { payload: { type } }) => {
  const { [type]: errorToRemove, ...lookup } = state.lookup;
  return {
    ...state,
    lookup,
    shown: false,
  };
};
